// 常用参数
const parameters = {
    baseURL: window.location.protocol + "//" + window.location.hostname,
    // baseURL: 'https://app.yantaiche.cn',
    // baseURL: "https://apptest.yantaiche.cn",
};

export default parameters;


// WEBPACK FOOTER //
// ./src/utils/parameters.js